import type { Country } from '@/helpers/conf';
import { ANJOUAN_COUNTRIES } from '../constants';

export interface IPolicies {
  textTabique: string;
  textAnjouan: string;
}

export const getPoliciesByCountryCode = (
  countryCode: Country,
  data: IPolicies
) => {
  if (ANJOUAN_COUNTRIES.includes(countryCode)) return data.textAnjouan;
  return data.textTabique;
};
